import { Properties as ObjectProperties } from "./Properties";
export var _Object;
(function (_Object) {
    _Object.Properties = ObjectProperties;
})(_Object || (_Object = {}));
//# sourceMappingURL=index.js.map